function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import facebookImage from 'shared/images/icon-facebook-rubriq.svg';
import instagramImage from 'shared/images/icon-instagram-rubriq.svg';
import linkedinImage from 'shared/images/icon-linkedin-rubriq.svg';
import twitterImage from 'shared/images/icon-twitter-rubriq.svg';
import qrCode from 'shared/images/qr-code.png';
import bilibiliImage from 'shared/images/icon-bilibili.svg';
import douyinImage from 'shared/images/icon-douyin.svg';
import redbookImage from 'shared/images/icon-redbook.svg';
import weiboImage from 'shared/images/icon-weibo.svg';
import zhihuImage from 'shared/images/icon-zhihu.svg';
import featureEnabled from 'shared/helper/feature';
var restrictLanguages = featureEnabled('rubriq_restrict_languages');
var filterLanguages = function filterLanguages(obj) {
  if (!restrictLanguages) return obj;
  var allowed = ['en', 'cn'];
  return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      lang = _ref2[0];
    return allowed.includes(lang);
  }));
};
export default {
  bookEditingQuote: {
    default: 'https://support.aje.com/hc/en-us/requests/new?ticket_form_id=360000195952',
    br: 'https://support.aje.com/hc/pt-br/requests/new?ticket_form_id=360000195952',
    cn: 'https://support.aje.com/hc/zh-cn/requests/new?ticket_form_id=360000195952',
    en: 'https://support.aje.com/hc/en-us/requests/new?ticket_form_id=360000195952',
    es: 'https://support.aje.com/hc/es/requests/new?ticket_form_id=360000195952',
    jp: 'https://support.aje.com/hc/ja/requests/new?ticket_form_id=360000195952'
  },
  customQuote: {
    default: 'https://www.aje.com/%(language)s/services/figures/#request-a-quote',
    en: 'https://www.aje.com/services/figures/#request-a-quote',
    cn: 'https://www.aje.cn/services/figures/#request-a-quote'
  },
  digitalEditing: {
    default: 'https://www.aje.com/%(language)s/services/digital',
    en: 'https://www.aje.com/services/digital',
    cn: 'https://www.aje.cn/services/digital'
  },
  digitalEditingSurvey: {
    default: 'https://form.typeform.com/to/jeWQpyzS?typeform-medium=embed-snippet',
    br: 'https://researchsquare.typeform.com/to/FzjR1Vl6?typeform-medium=embed-snippet',
    cn: 'https://researchsquare.typeform.com/to/lGBd14wq?typeform-medium=embed-snippet',
    en: 'https://researchsquare.typeform.com/to/jeWQpyzS?typeform-medium=embed-snippet',
    es: 'https://researchsquare.typeform.com/to/LhxcLa5v?typeform-medium=embed-snippet',
    jp: 'https://researchsquare.typeform.com/to/riYELBnS?typeform-medium=embed-snippet'
  },
  digitalTranslationsSurvey: {
    default: 'https://form.typeform.com/to/h1lSfIfP?typeform-medium=embed-snippet',
    br: 'https://researchsquare.typeform.com/to/Nwz2TBVW?typeform-medium=embed-snippet',
    cn: 'https://researchsquare.typeform.com/to/GiLShDJ7?typeform-medium=embed-snippet',
    en: 'https://researchsquare.typeform.com/to/h1lSfIfP?typeform-medium=embed-snippet',
    es: 'https://researchsquare.typeform.com/to/daK3nJDv?typeform-medium=embed-snippet',
    jp: 'https://researchsquare.typeform.com/to/h1lSfIfP?typeform-medium=embed-snippet'
  },
  fapiaoCustomerSupportLink: 'https://www.aje.cn/submit-a-request',
  languageAssessmentSurvey: {
    default: 'https://researchsquare.typeform.com/to/zqcbJcFg',
    br: 'https://researchsquare.typeform.com/to/EnxfHHAu',
    cn: 'https://researchsquare.typeform.com/to/wKL84y6l',
    en: 'https://researchsquare.typeform.com/to/zqcbJcFg',
    es: 'https://researchsquare.typeform.com/to/SORRgfG7',
    jp: 'https://researchsquare.typeform.com/to/rfpoA21Y'
  },
  digitalEditingVideo: {
    default: 'https://iframe.videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2?defaultTextTrack=%(language)s&poster=https://videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2/thumbnails/thumbnail.jpg?time=7s',
    cn: 'https://iframe.videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2?defaultTextTrack=zh&poster=https://videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2/thumbnails/thumbnail.jpg?time=7s',
    jp: 'https://iframe.videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2?defaultTextTrack=ja&poster=https://videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2/thumbnails/thumbnail.jpg?time=7s',
    br: 'https://iframe.videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2?defaultTextTrack=pt&poster=https://videodelivery.net/5e9bec2719d6a1d8a36fad496188f4c2/thumbnails/thumbnail.jpg?time=7s'
  },
  referralLink: {
    default: 'https://secure.aje.com/%(language)s/r/%(referralCode)s',
    en: 'https://secure.aje.com/r/%(referralCode)s',
    cn: 'https://china.aje.com/r/%(referralCode)s'
  },
  scientificReworkLink: {
    default: 'https://www.aje.com/submit-a-request'
  },
  header: filterLanguages({
    en: [{
      title: 'Services',
      children: [{
        title: 'Services',
        url: 'https://www.aje.com/services/'
      }, {
        title: 'Editing',
        url: 'https://www.aje.com/services/editing/'
      }, {
        title: 'Translation',
        url: 'https://www.aje.com/services/translation/'
      }, {
        title: 'Formatting',
        url: 'https://www.aje.com/services/formatting/'
      }, {
        title: 'Figure Preparation',
        url: 'https://www.aje.com/services/figures/'
      }, {
        title: 'Table Formatting',
        url: 'https://www.aje.com/services/figures/'
      }, {
        title: 'Custom Illustration',
        url: 'https://www.aje.com/services/illustrations/'
      }, {
        title: 'Journal Recommendation',
        url: 'https://www.aje.com/services/journal-recommendation/'
      }, {
        title: 'Scientific Editing',
        url: 'https://www.aje.com/services/scientific-editing/'
      }]
    }, {
      title: 'Prices',
      children: [{
        title: 'Prices',
        url: 'https://www.aje.com/pricing/'
      }, {
        title: 'AJE Rewards',
        url: 'https://www.aje.com/aje-rewards/'
      }, {
        title: 'Group Discounts',
        url: 'https://www.aje.com/group-discounts/'
      }, {
        title: 'Price Quote',
        url: 'https://secure.aje.com/en/prices/quote/new/'
      }]
    }, {
      title: 'About Us',
      children: [{
        title: 'About Us',
        url: 'https://www.aje.com/about/'
      }, {
        title: 'Meet Our Team',
        url: 'https://www.aje.com/about/our-team/'
      }, {
        title: 'Areas of Study',
        url: 'https://www.aje.com/about/areas-of-study/'
      }]
    }, {
      title: 'Free Resources',
      children: [{
        title: 'Resource Center',
        url: 'https://www.aje.com/en/arc/'
      }, {
        title: 'Webinars',
        url: 'https://www.aje.com/arc/webinars/'
      }, {
        title: 'Writing Guides',
        url: 'https://www.aje.com/arc/media_type/#!/downloadable'
      }]
    }],
    jp: [{
      title: 'Services',
      children: [{
        title: 'Services',
        url: 'https://www.aje.com/jp/services/'
      }, {
        title: 'Editing',
        url: 'https://www.aje.com/jp/services/editing/'
      }, {
        title: 'Translation',
        url: 'https://www.aje.com/jp/services/translation/'
      }, {
        title: 'Figure Services',
        url: 'https://www.aje.com/jp/services/figures/'
      }, {
        title: 'Formatting',
        url: 'https://www.aje.com/jp/services/formatting/'
      }, {
        title: 'Table Formatting',
        url: 'https://www.aje.com/jp/services/figures/'
      }, {
        title: 'Custom Illustration',
        url: 'https://www.aje.com/jp/services/illustrations/'
      }, {
        title: 'Journal Recommendation',
        url: 'https://www.aje.com/jp/services/journal-recommendation/'
      }, {
        title: 'Scientific Editing',
        url: 'https://www.aje.com/jp/services/scientific-editing/'
      }]
    }, {
      title: 'Prices',
      children: [{
        title: 'Prices',
        url: 'https://www.aje.com/jp/pricing/'
      }, {
        title: 'AJE Rewards',
        url: 'https://www.aje.com/jp/aje-rewards/'
      }, {
        title: 'Group Discounts',
        url: 'https://www.aje.com/jp/group-discounts/'
      }, {
        title: 'Price Quote',
        url: 'https://secure.aje.com/jp/prices/quote/new/'
      }]
    }, {
      title: 'About Us',
      children: [{
        title: 'About Us',
        url: 'https://www.aje.com/jp/about/'
      }, {
        title: 'Meet Our Team',
        url: 'https://www.aje.com/jp/about/our-team/'
      }, {
        title: 'Areas of Study',
        url: 'https://www.aje.com/jp/about/areas-of-study/'
      }]
    }, {
      title: 'Resources',
      url: 'https://www.aje.com/jp/arc/'
    }],
    cn: [{
      title: 'Services',
      children: [{
        title: 'Services',
        url: 'https://www.aje.cn/services/'
      }, {
        title: 'Editing',
        url: 'https://www.aje.cn/services/editing/'
      }, {
        title: 'Figure Services',
        url: 'https://www.aje.cn/services/figures/'
      }, {
        title: 'Formatting',
        url: 'https://www.aje.cn/services/formatting/'
      }, {
        title: 'Translation',
        url: 'https://www.aje.cn/services/translation/'
      }, {
        title: 'Table Formatting',
        url: 'https://www.aje.cn/services/figures/'
      }, {
        title: 'Custom Illustration',
        url: 'https://www.aje.cn/services/illustrations/'
      }, {
        title: 'Journal Recommendation',
        url: 'https://www.aje.cn/services/journal-recommendation/'
      }, {
        title: 'Scientific Editing',
        url: 'https://www.aje.cn/services/scientific-editing/'
      }]
    }, {
      title: 'Prices',
      children: [{
        title: 'Prices',
        url: 'https://www.aje.cn/pricing/'
      }, {
        title: 'AJE Rewards',
        url: 'https://www.aje.cn/aje-rewards/'
      }, {
        title: 'Group Discounts',
        url: 'https://www.aje.cn/group-discounts/'
      }, {
        title: 'Price Quote',
        url: 'https://www.aje.cn/prices/quote/new/'
      }]
    }, {
      title: 'About Us',
      children: [{
        title: 'About Us',
        url: 'https://www.aje.cn/about/'
      }, {
        title: 'Meet Our Team',
        url: 'https://www.aje.cn/about/our-team/'
      }, {
        title: 'Areas of Study',
        url: 'https://www.aje.cn/about/areas-of-study/'
      }]
    }, {
      title: 'Resources',
      url: 'https://www.aje.cn/arc/'
    }],
    es: [{
      title: 'Services',
      children: [{
        title: 'Services',
        url: 'https://www.aje.com/es/services/'
      }, {
        title: 'Editing',
        url: 'https://www.aje.com/es/services/editing/'
      }, {
        title: 'Translations',
        url: 'https://www.aje.com/es/services/translation/'
      }, {
        title: 'Formatting',
        url: 'https://www.aje.com/es/services/formatting/'
      }, {
        title: 'Figure Preparation',
        url: 'https://www.aje.com/es/services/figures/'
      }, {
        title: 'Table Formatting',
        url: 'https://www.aje.com/es/services/figures/'
      }, {
        title: 'Custom Illustration',
        url: 'https://www.aje.com/es/services/illustrations/'
      }, {
        title: 'Journal Recommendation',
        url: 'https://www.aje.com/es/services/journal-recommendation/'
      }, {
        title: 'Scientific Editing',
        url: 'https://www.aje.com/es/services/scientific-editing/'
      }]
    }, {
      title: 'Prices',
      children: [{
        title: 'Prices',
        url: 'https://www.aje.com/es/pricing/'
      }, {
        title: 'AJE Rewards',
        url: 'https://www.aje.com/es/aje-rewards/'
      }, {
        title: 'Group Discounts',
        url: 'https://www.aje.com/es/group-discounts/'
      }, {
        title: 'Price Quote',
        url: 'https://secure.aje.com/es/prices/quote/new/'
      }]
    }, {
      title: 'About Us',
      children: [{
        title: 'About Us',
        url: 'https://www.aje.com/es/about/'
      }, {
        title: 'Meet Our Team',
        url: 'https://www.aje.com/es/about/our-team/'
      }, {
        title: 'Areas of Study',
        url: 'https://www.aje.com/es/about/areas-of-study/'
      }]
    }, {
      title: 'Resources',
      url: 'https://www.aje.com/es/arc/'
    }],
    br: [{
      title: 'Services',
      children: [{
        title: 'Services',
        url: 'https://www.aje.com/br/services/'
      }, {
        title: 'Editing',
        url: 'https://www.aje.com/br/services/editing/'
      }, {
        title: 'Translations',
        url: 'https://www.aje.com/br/services/translation/'
      }, {
        title: 'Formatting',
        url: 'https://www.aje.com/br/services/formatting/'
      }, {
        title: 'Figure Preparation',
        url: 'https://www.aje.com/br/services/figures/'
      }, {
        title: 'Table Formatting',
        url: 'https://www.aje.com/br/services/figures/'
      }, {
        title: 'Custom Illustration',
        url: 'https://www.aje.com/br/services/illustrations/'
      }, {
        title: 'Journal Recommendation',
        url: 'https://www.aje.com/br/services/journal-recommendation/'
      }, {
        title: 'Scientific Editing',
        url: 'https://www.aje.com/br/services/scientific-editing/'
      }]
    }, {
      title: 'Prices',
      children: [{
        title: 'Prices',
        url: 'https://www.aje.com/br/pricing/'
      }, {
        title: 'AJE Rewards',
        url: 'https://www.aje.com/br/aje-rewards/'
      }, {
        title: 'Group Discounts',
        url: 'https://www.aje.com/br/group-discounts/'
      }, {
        title: 'Price Quote',
        url: 'https://secure.aje.com/br/prices/quote/new/'
      }]
    }, {
      title: 'About Us',
      children: [{
        title: 'About Us',
        url: 'https://www.aje.com/br/about/'
      }, {
        title: 'Meet Our Team',
        url: 'https://www.aje.com/br/about/our-team/'
      }, {
        title: 'Areas of Study',
        url: 'https://www.aje.com/br/about/areas-of-study/'
      }]
    }, {
      title: 'Resources',
      url: 'https://www.aje.com/br/arc/'
    }]
  }),
  footer: filterLanguages({
    en: {
      left: [{
        title: 'products',
        links: [{
          title: 'Features',
          url: 'https://www.rubriq.com/features/'
        }, {
          title: 'Pricing',
          url: 'https://www.rubriq.com/pricing/'
        }, {
          title: 'Resources',
          url: 'https://www.rubriq.com/resources/'
        }, {
          title: 'For Institutions',
          url: 'https://www.rubriq.com/institutions/'
        }]
      }],
      right: [{
        title: 'company',
        links: [{
          title: 'Support',
          url: 'https://customer-support.aje.com/portal/en/kb/rubriq'
        }, {
          title: 'About AJE',
          url: 'https://www.aje.com/about/'
        }, {
          title: 'Privacy Policy',
          url: 'https://www.rubriq.com/security-and-privacy/'
        }, {
          title: 'Terms of Service',
          url: 'https://www.rubriq.com/terms-of-service'
        }]
      }]
    },
    jp: {
      left: [{
        title: '製品',
        links: [{
          title: '機能',
          url: 'https://www.rubriq.com/jp/features/'
        }, {
          title: '料金',
          url: 'https://www.rubriq.com/jp/pricing/'
        }, {
          title: 'リソース',
          url: 'https://www.rubriq.com/jp/resources/'
        }, {
          title: '大学・研究機関向け',
          url: 'https://www.rubriq.com/jp/institutions/'
        }]
      }],
      right: [{
        title: '会社情報',
        links: [{
          title: 'サポート',
          url: 'https://www.rubriq.com/jp/support/'
        }, {
          title: 'AJEについて',
          url: 'https://www.aje.com/jp/about/'
        }, {
          title: 'プライバシーポリシー',
          url: 'https://www.rubriq.com/jp/security-and-privacy/'
        }, {
          title: '利用規約',
          url: 'https://www.rubriq.com/jp/terms-of-service'
        }]
      }]
    },
    cn: {
      left: [{
        title: '产品',
        links: [{
          title: '功能',
          url: 'https://rubriq.cn/features/'
        }, {
          title: '定价',
          url: 'https://rubriq.cn/pricing/'
        }, {
          title: '资源',
          url: 'https://rubriq.cn/resources/'
        }, {
          title: '面向机构',
          url: 'https://rubriq.cn/institutions/'
        }]
      }],
      right: [{
        title: '公司',
        links: [{
          title: '支持',
          url: 'https://customer-support.aje.com/portal/zh/kb/rubriq'
        }, {
          title: '关于AJE',
          url: 'https://www.aje.com/cn/about/'
        }, {
          title: '隐私政策',
          url: 'https://rubriq.cn/security-and-privacy/'
        }, {
          title: '服务条款',
          url: 'https://rubriq.cn/terms-of-service'
        }]
      }]
    },
    es: {
      left: [{
        title: 'productos',
        links: [{
          title: 'Funciones',
          url: 'https://www.rubriq.com/es/features/'
        }, {
          title: 'Precios',
          url: 'https://www.rubriq.com/es/pricing/'
        }, {
          title: 'Recursos',
          url: 'https://www.rubriq.com/es/resources/'
        }, {
          title: 'Para Instituciones',
          url: 'https://www.rubriq.com/es/institutions/'
        }]
      }],
      right: [{
        title: 'compañía',
        links: [{
          title: 'Soporte',
          url: 'https://www.rubriq.com/es/support/'
        }, {
          title: 'Sobre AJE',
          url: 'https://www.aje.com/es/about/'
        }, {
          title: 'Política de Privacidad',
          url: 'https://www.rubriq.com/es/security-and-privacy/'
        }, {
          title: 'Términos del Servicio',
          url: 'https://www.rubriq.com/es/terms-of-service'
        }]
      }]
    },
    br: {
      left: [{
        title: 'produtos',
        links: [{
          title: 'Recursos',
          url: 'https://www.rubriq.com/br/features/'
        }, {
          title: 'Preços',
          url: 'https://www.rubriq.com/br/pricing/'
        }, {
          title: 'Materiais',
          url: 'https://www.rubriq.com/br/resources/'
        }, {
          title: 'Para Instituições',
          url: 'https://www.rubriq.com/br/institutions/'
        }]
      }],
      right: [{
        title: 'empresa',
        links: [{
          title: 'Suporte',
          url: 'https://www.rubriq.com/br/support/'
        }, {
          title: 'Sobre a AJE',
          url: 'https://www.aje.com/br/about/'
        }, {
          title: 'Política de Privacidade',
          url: 'https://www.rubriq.com/br/security-and-privacy/'
        }, {
          title: 'Termos de Serviço',
          url: 'https://www.rubriq.com/br/terms-of-service'
        }]
      }]
    }
  }),
  socialMedia: filterLanguages({
    en: [{
      img: twitterImage,
      title: 'Follow us on Twitter',
      url: 'https://twitter.com/journalexperts'
    }, {
      img: facebookImage,
      title: 'Join us on Facebook',
      url: 'https://www.facebook.com/AmericanJournalExperts/'
    }, {
      img: instagramImage,
      title: 'Follow us on Instagram',
      url: 'https://www.instagram.com/americanjournalexperts/'
    }, {
      img: linkedinImage,
      title: 'Connect on Linkedin',
      url: 'https://www.linkedin.com/company/american-journal-experts'
    }],
    br: [{
      img: facebookImage,
      url: 'https://www.facebook.com/brasil.aje/',
      title: 'Join us on Facebook'
    }, {
      img: twitterImage,
      url: 'https://twitter.com/journalexperts',
      title: 'Follow us on Twitter'
    }, {
      img: linkedinImage,
      url: 'https://www.linkedin.com/company/american-journal-experts',
      title: 'Connect on Linkedin'
    }, {
      img: instagramImage,
      url: 'https://www.instagram.com/americanjournalexperts/',
      title: 'Follow us on Instagram'
    }],
    cn: [{
      img: bilibiliImage,
      url: 'https://space.bilibili.com/2099009306'
    }, {
      img: zhihuImage,
      url: 'https://www.zhihu.com/org/aje.cn'
    }, {
      img: weiboImage,
      url: 'https://weibo.com/AJEChina/'
    }, {
      img: redbookImage,
      url: 'https://www.xiaohongshu.com/user/profile/6385b934000000001f017f05'
    }, {
      img: douyinImage,
      url: 'https://www.douyin.com/user/MS4wLjABAAAAMAFGiIHIjUcuBO52a52fFFZJHJtwFXznzIaY7HaeFVeb1b-CNOhmBY7f8J0wP6YQ'
    }]
  }),
  qr: filterLanguages({
    en: [],
    cn: [{
      text: 'qr-code-text',
      labelClassName: 'qr-label-cn',
      codeClassName: 'qr-code-cn',
      img: qrCode
    }]
  })
};